import { render } from "./cashboxSetup.vue?vue&type=template&id=4a14259e"
import script from "./cashboxSetup.vue?vue&type=script&lang=js"
export * from "./cashboxSetup.vue?vue&type=script&lang=js"

import "./cashboxSetup.vue?vue&type=style&index=0&id=4a14259e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__